const TOKEN_KEY = "dashboard_token";
const USER_KEY = "dashboard_user";
const EXPIRES_AT_KEY = "dashboard_expires_at";
const JOB_MANAGER_TOKEN_KEY = "jm_token";

export function getDashboardToken() {
  return sessionStorage.getItem(TOKEN_KEY) || "";
}

export function getDashboardUser() {
  return sessionStorage.getItem(USER_KEY) || "";
}

export function getDashboardExpiresAt() {
  return Number(sessionStorage.getItem(EXPIRES_AT_KEY) || 0);
}

export function isDashboardTokenValid() {
  const token = getDashboardToken();
  const expiresAt = getDashboardExpiresAt();

  return Boolean(token && expiresAt && expiresAt > Date.now());
}

export function saveDashboardAuth({ token, username, expiresAt }) {
  sessionStorage.setItem(TOKEN_KEY, token || "");
  sessionStorage.setItem(USER_KEY, username || "");
  sessionStorage.setItem(EXPIRES_AT_KEY, String(expiresAt || 0));
}

export function clearDashboardAuth() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(EXPIRES_AT_KEY);
  sessionStorage.removeItem(JOB_MANAGER_TOKEN_KEY);
}

export function clearJobManagerAuth() {
  sessionStorage.removeItem(JOB_MANAGER_TOKEN_KEY);
}

export { TOKEN_KEY, USER_KEY, EXPIRES_AT_KEY, JOB_MANAGER_TOKEN_KEY };
